import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Hammer, Mail, CheckCircle, ArrowLeft } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { cn } from '../../utils/formatters';
import { input, label } from '../../styles/components';

export function ForgotPasswordPage() {
  const { requestPasswordReset } = useAuth();
  const [email, setEmail] = useState('');
  const [isSending, setIsSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsSending(true);
    const result = await requestPasswordReset(email.trim());
    setIsSending(false);
    if (result.success) {
      setSent(true);
    } else {
      setError(result.error || 'No se pudo enviar la solicitud');
    }
  };

  return (
    <div className="space-y-6">
      <div className="text-center space-y-3">
        <Link to="/" className="inline-flex items-center gap-2">
          <span className="w-12 h-12 rounded-xl flex items-center justify-center bg-[var(--b2b-accent)]">
            <Hammer className="w-7 h-7 text-white" />
          </span>
          <span className="text-2xl font-extrabold tracking-tight">ReformAll</span>
        </Link>
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight">Recuperar contraseña</h1>
          <p className="b2b-muted">Te enviaremos un enlace para restablecerla</p>
        </div>
      </div>

      <div className="b2b-panel p-8">
        {sent ? (
          <div className="text-center space-y-4">
            <div className="mx-auto w-16 h-16 rounded-full flex items-center justify-center bg-[var(--b2b-surface-muted)]">
              <CheckCircle className="w-8 h-8 text-[color:var(--b2b-accent-strong)]" />
            </div>
            <h2 className="text-xl font-bold">Revisa tu correo</h2>
            <p className="b2b-muted">
              Si <strong>{email}</strong> está registrado, recibirás un enlace para restablecer tu contraseña.
              El enlace caduca en 1 hora.
            </p>
            <Link to="/login" className="b2b-btn b2b-btn--ghost w-full justify-center">
              <ArrowLeft className="w-4 h-4" />
              Volver al login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className={label} htmlFor="email">Email</label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 b2b-muted" />
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className={cn(input, 'pl-9')}
                  placeholder="tu@email.com"
                  autoComplete="email"
                  required
                />
              </div>
            </div>

            {error && <p className="text-sm text-[color:var(--b2b-danger)]">{error}</p>}

            <button type="submit" disabled={isSending} className="b2b-btn b2b-btn--primary w-full justify-center disabled:opacity-60">
              <Mail className="w-4 h-4" />
              {isSending ? 'Enviando...' : 'Enviar enlace'}
            </button>

            <p className="text-center text-sm b2b-muted">
              <Link to="/login" className="font-medium text-[color:var(--b2b-accent-strong)] hover:underline">
                Volver al login
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
